import React from "react";
import { Card } from "react-bootstrap";

const InstructionCard = () => {
  const msg = `Process to Add a GET API
1. Add the API URL in requested url window.
2. In the URL, include the replace template text with {MESSAGE} and mobile number 10 digit with {PHONE}.
3. Add template text in the sms text window.

Example :
Request URL window: https://XXX.XXX.in/api/pushsms?user=AAAA&authkey=posTHBB&sender=XXXX&mobile={PHONE}&text={MESSAGE}&templateid=XXXX&rpt=1
Please Paste the SMS text here : Dear customer,  is the OTP for your login at . In case you have not requested this, please contact us at .

⸻

Process to Add a POST API

Option 1: Using cURL
1. Paste the cURL into the tool.
2. Verify that the header and body values are entered correctly.
3. Once confirmed, click the Test button.
• If everything is correct, you should receive a status 200 response.
4. After a successful test, check the body section:
• Find the mobile number and replace the 10-digit mobile number with {PHONE}.
5. Press Submit.
6. Finally, click Add SMS Webhook.

⸻

If you face any issues, please connect with the support team.`;

  return (
    <Card className="h-100">
      <Card.Header className="sub-header">Instructions</Card.Header>
      <Card.Body style={{ overflowY: "auto", maxHeight: "70vh" }}>
        <pre style={{ whiteSpace: "pre-wrap", fontSize: "0.95rem" }}>
          {msg}
        </pre>
      </Card.Body>
    </Card>
  );
};

export default InstructionCard;


